import React, {useState } from "react";
import { Row, Col } from "antd";
import UserHeader from "../../components/header/UserHeader";
import UserDrawer from "../../components/drawer/UserDrawer";
import { useNavigate } from "react-router-dom";
import "./underConstructionStyle.css"
import goBackButton from "../../assets/images/Go_Back.svg";
import bottomImage from "../../assets/images/bottom_bg.png"
import underConstruction from "../../assets/images/under_construction.png"
import topImage from "../../assets/images/top_bg.png"

function LandingPage() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  function handleGoBackButton() {
    navigate("/landing-page");
  }

  const sectionsContainerStyle = {
    transition: "opacity 0.3s ease, pointer-events 0.3s ease",
    opacity: isDrawerOpen ? "0.5" : "1",
    pointerEvents: isDrawerOpen ? "none" : "auto",
  };


  return (
    <div style={{ minHeight: "100dvh", overflow: "hidden", background: "#fff" }}>
      <Col xs={24} sm={24} lg={24} md={24} style={sectionsContainerStyle}>
        <Row
          justify={{
            xs: "space-around",
            md: "space-around",
            lg: "space-between",
          }}
          style={{ marginBottom: 10 }}
        >
          <Col xs={{ span: 23 }} lg={{ span: 24 }} md={{ span: 23 }}>
            <UserHeader setDrawer={openDrawer} />
          </Col>
          {isDrawerOpen && (
            <Col span={4}>
              <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
            </Col>
          )}
        </Row>
        <Row>
          <Col>
            <img src={topImage} alt="Top background" className="topFix" />
          </Col>
        </Row>
        <Row justify="left">
          <Col className="go-back-button flex-1">
            <button onClick={handleGoBackButton} className="button-styling setBackButton">
              <img src={goBackButton} alt="Go Back Button" />
            </button>
          </Col>
        </Row>
        <Row justify="center" align="center" style={{ margin: 65 }}>
          <img src={underConstruction} alt="underConstruction"/>
        </Row>
        <img src={bottomImage} alt="bottom background" className="fix" />

      </Col>
    </div>
  );
}

export default LandingPage;